import { MessageSquare, Sparkles, Star } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const automateRequestingReviewOnlyWhenTheCustomerIsHappyAr: TemplateAr =
  {
    name: 'أتمتة طلب التقييم بس لمّا يكون العميل راضي بالذكاء الاصطناعي',
    description:
      'اطلب التقييمات بذكاء بعد التفاعلات الإيجابية بس. الذكاء الاصطناعي يرصد رضا العميل ويرسل طلب التقييم في اللحظة المثالية.',
    category: 'دعم العملاء',
    workflow: [
      { icon: MessageSquare, label: 'عميل راضٍ' },
      { icon: Sparkles, label: 'الـ AI يرصد' },
      { icon: Star, label: 'طلب تقييم', final: true },
    ],
    detailDescription: {
      paragraph1:
        'اطلب التقييم بعد التفاعل الإيجابي بس، مو من كل من يخلص محادثة. الـ AI يحلل مشاعر المحادثة وجودة الحل وإشارات رضا العميل عشان يحدد اللحظة المثالية للطلب. وما يطلب تقييماً أبداً بعد تجربة سلبية، فيحمي تقييماتك العلنية وعلاقتك بعملائك.',
      paragraph2:
        'الطلب يوصل بالإيميل أو الرسائل النصية أو داخل التطبيق، في التوقيت المثالي. والحملات ومعدلات الاستجابة تتابعها في أدوات التحليلات عندك. والـ AI يتعلّم أي العملاء أقرب لترك تقييم، ويحسّن توقيت الطلب على أساس ذلك.',
    },
    benefits: [
      'اطلب التقييم من العملاء الراضين بس',
      'متوسط تقييماتك يرتفع وتلاحظ الفرق',
      'معدل الاستجابة لطلبات التقييم يرتفع',
      'يحمي سمعة علامتك',
      'يأتمت جمع التقييمات من أوله لآخره',
      'الـ AI يتعلّم التوقيت الأمثل من أنماط الاستجابة',
    ],
  };
